export const constants = {
    // NAME OF THE SIDEBAR COMPONENTS
    SIDENAVITEMS : [
        { id: "dashboard", name: "Dashboard", subItems: [], path: "app/dashboard", icon: "icon-dashboard" },
        {
            id: "inventory",
            name: "Inventory",
            subItems: [
                { 
                    id: "stock",
                    name: "Stock", 
                    subItems: [
                        { id: "stockUpdate", name: "Update", subItems: [], path: "app/inventory/stock/update" }, 
                        { id: "stockView", name: "View", subItems: [], path: "app/inventory/stock/view" }
                    ]
                },
                {
                    id: "product",
                    name: "Product",
                    subItems: [
                        { id: "productAdd", name: "Add", subItems: [], path: "app/inventory/product/add" },
                        { id: "productView",name: "View", subItems: [], path: "app/inventory/product/view" }
                    ]
                },
            ],
            icon: "icon-dashboard"
        },
        {
            id: "sales",
            name: "Sales",
            subItems: [
                { id: "addSales", name: "Add Sales", subItems: [], path: "app/sales/addsales" },
                { id: "viewSales", name: "View Sales", subItems: [], path: "app/sales/viewsales" },
                { id: "deliverSales", name: "Deliver Sales", subItems: [], path: "app/sales/deliversales" },
                { id: "returnSales", name: "Return Sales", subItems: [], path: "app/sales/returnsales" },
                { id: "cancelSales", name: "Cancel Sales", subItems: [], path: "app/sales/cancelsales" },
                { id: "viewSlips", name: "View Slips", subItems: [], path: "app/sales/viewslips" }
            ],
            icon: "icon-dashboard"
        },
        {
            id: "system",
            name: "System",
            subItems: [
                { id: "productGroups", name: "Product Groups", subItems: [], path: "app/system/productgroups" },
                { id: "itemGroups", name: "Item Groups", subItems: [], path: "app/system/itemgroups" },
                { id: "attributes", name: "Attributes", subItems: [], path: "app/system/attributes" },
                { id: "workflowStates", name: "Workflow States", subItems: [], path: "app/system/workflowstates" },
                { id: "customers", name: "Customers", subItems: [], path: "app/system/customers" },
                { id: "agents", name: "Agents", subItems: [], path: "app/system/agents" },
                { id: "shipping", name: "Shipping", subItems: [], path: "app/system/shipping" },
                { id: "labelDetails", name: "Label Details", subItems: [], path: "app/system/labeldetails" }
            ],
            icon: "icon-dashboard"
        },
        {
            id: "reports",
            name: "Reports",
            subItems: [
                { 
                    id: "salesOrder",
                    name: "Sales Order", 
                    subItems: [
                        { id: "partywiseOrder", name: "Partywise", subItems: [], path: "app/reports/salesOrder/partywise" },
                        { id: "productwiseOrder", name: "Productwise", subItems: [], path: "app/reports/salesOrder/productwise" },
                        { id: "packagingSlipsReport", name: "Packaging Slips", subItems: [], path: "app/reports/salesOrder/packagingSlips" },
                        { id: "partyPendingReadyOrder", name: "Pending Ready Order", subItems: [], path: "app/reports/salesOrder/pendingReadyOrder" }
                    ]
                },
                {
                    id: "stock",
                    name: "Stock",
                    subItems: [
                        { id: "stockSizewise", name: "Sizewise", subItems: [], path: "app/reports/stock/sizewise" }
                    ]
                },
            ],
            icon: "icon-dashboard"
        }
    ],

    FACTOR_VALUES_COUNT : 15,
    ATTRIBUTES_COUNT : 5,
    STATE_VALUES_COUNT : 5,

    ATTRIBUTES_GRID_MAX_ROWS : 8,
    PRODUCT_ADD_GRID_MAX_ROWS : 10,
    SMALL_PAGE_GRID_MAX_ROWS : 10,
    MEDIUM_PAGE_GRID_MAX_ROWS : 15,
    FULL_PAGE_GRID_MAX_ROWS : 20,
    WORKFLOW_STATES_GRID_MAX_ROWS : 30,
    DEFAULT_LIST_MAX_ROWS : 20,
    MOADL_GRID_MAX_ROWS : 15,

    FACTOR_RATES_KEY: ['mrp', 'rate'],
    MRP_FACTORS_KEYS: ['mrp', 'rates'],
    ATTRIBUTE_FACTORS: ['name', 'options'],
    PRODUCT_TABLE_ROWS_TITLE: ['Mrp', 'Rates', 'Quantity'],
    PENDING_READY_ROWS_TITLE: ['Pending', 'Ready'],
    STOCK_CATEGORY: [{id: 'total', name: 'Total'}, {id:'defect', name: 'Defect'}],
    
    VIEW: 'view',
    EDIT: 'edit',
    ADD: 'add',
    DELETE: 'delete',
    PRINT: 'print',
    ALREADY_EXISTS_STRING: 'exists',

    KEY_SHIFT: 'Shift',
    KEY_LEFT_ALT: 'Alt',
    
    trueBackdropModals: ['#packaging-slip-modal'],
    keyboardListeningModals: ['#packaging-slip-modal'],

    TYPING_INTERVAL: 1000,

    SQL_QUERY_ROW_LIMIT: 100,

    TOTAL_ORDER: 'total_order',
    PENDING_ORDER: 'pending_order',
    DELIVERED_ORDER: 'delivered_order',
    RETURNED_ORDER: 'returned_order',
    CANCELLED_ORDER: 'cancelled_order',
    AGGREGATE_ORDER: 'aggregate_order',

    ORDER_SECTIONS_LIST: [
        { id: 'total_order', name: 'Total' }, 
        { id: 'pending_order', name: 'Pending' },
        { id: 'delivered_order', name: 'Delivered' },
        { id: 'returned_order', name: 'Returned' }, 
        { id: 'cancelled_order', name: 'Cancelled' },
        { id: 'aggregate_order', name: 'Aggregate' }
    ],

    ORDER_SECTIONS_DICT: {
        total_order: 'Total',
        pending_order: 'Pending',
        delivered_order: 'Delivered',
        returned_order: 'Returned',
        cancelled_order: 'Cancelled',
        aggregate_order: 'Aggregate'
    } as any,

    VIEW_OPTIONS_LIST: [ {id: 'item_group', name: 'Item Group'}, { id: 'design', name: 'Design'} ],

    CUSTOMER_ID: "customer_id",
    AGENT_ID: "agent_id",
    STATE_ID: "state_id",

    ACCESS_DELTA_TIME: 56, // In minutes - 4 minutes less than an hour to refresh before it expires on backend (local - 10)
    REFRESH_DELTA_TIME: 2870, // In minutes - 10 minutes less than 2 days (local - 110)

    PDF_TABLE_HEAD_FOOT_STYLES: {
        fillColor: '#f5f7f7',
        lineWidth: {
            bottom: 0.2,
            top: 0.2,
            left: 0.2,
            right: 0.2
        },
    },
    PDF_TABLE_ROW_STYLES: {
        fontSize: 7,
        textColor: '#363838',
        lineColor: '#363838',
        cellPadding: {
          top: 1,
          right: 1,
          bottom: 1,
          left: 1
        },
    },

    PREFIX_TYPES: [
        {id: 'order', title: 'Sales Order'},
        {id: 'pkg_slip', title: 'Packaging Slip'},
        {id: 'invoice', title: 'Invoice'}
    ],  

    INDUSTRY: [
        {'id': 1, 'name': 'Agency or Sales House'},
        {'id': 2, 'name': 'Construction'},
        {'id': 3, 'name': 'Education'}, 
        {'id': 4, 'name': 'Engineering'}, 
        {'id': 5, 'name': 'Entertainment'}, 
        {'id': 6, 'name': 'Financial Services'}, 
        {'id': 7, 'name': 'Food Services'},
        {'id': 8, 'name': 'Government'},
        {'id': 9, 'name': 'Health Care'},
        {'id': 10, 'name': 'Interior Design'},
        {'id': 11, 'name': 'Manufacturing'},
        {'id': 12, 'name': 'Marketing'},
        {'id': 13, 'name': 'Mining and Logistics'},
        {'id': 14, 'name': 'Non-Profit'},
        {'id': 15, 'name': 'Retail (E-Commerce and Offline)'},
        {'id': 16, 'name': 'Services'},
        {'id': 17, 'name': 'Technology'},
        {'id': 18, 'name': 'Travel/Hospitality'}
    ]
}
